import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationModulesState } from './application-modules.reducer';

export const selectApplicationModulesState = createFeatureSelector<ApplicationModulesState>('applicationModules');

export const selectApplicationModulesByKey = (applicationGuid: string) =>
  createSelector(selectApplicationModulesState, (state) => state.modules[applicationGuid] || null);

export const selectApplicationModulesLoading = createSelector(selectApplicationModulesState, (state) => state.loading);

export const selectApplicationModulesError = createSelector(selectApplicationModulesState, (state) => state.error);
